// extracted by mini-css-extract-plugin
module.exports = {"buttons":"EHdwnW"};